let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3GzsM")).then(() => parcelRequire('ihKlr'));